import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

@Component({
  selector: 'app-status-pill',
  templateUrl: './status-pill.component.html',
  styleUrls: ['./status-pill.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class StatusPillComponent {
  @Input() icon = '';
  @Input() label = '';
  @Input() tone: 'success' | 'warning' | 'neutral' | 'danger' = 'neutral';
}
